import React from "react";

export default function FlowIcon({ name = "default", className = "" }) {
  const key = (name || "default").toLowerCase();
  switch (key) {
    case "bank":
      return (
        <svg
          className={className}
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 3L2 9h20L12 3z"
            stroke="#1F4FB6"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="#EAF2FF"
          />
          <path
            d="M6 10v6"
            stroke="#1F4FB6"
            strokeWidth="1.2"
            strokeLinecap="round"
          />
          <path
            d="M10 10v6"
            stroke="#1F4FB6"
            strokeWidth="1.2"
            strokeLinecap="round"
          />
          <path
            d="M14 10v6"
            stroke="#1F4FB6"
            strokeWidth="1.2"
            strokeLinecap="round"
          />
          <path
            d="M18 10v6"
            stroke="#1F4FB6"
            strokeWidth="1.2"
            strokeLinecap="round"
          />
        </svg>
      );
    case "invoice":
    case "bill":
      return (
        <svg
          className={className}
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="3"
            y="3"
            width="14"
            height="18"
            rx="2"
            fill="#fff"
            stroke="#1F4FB6"
            strokeWidth="1.2"
          />
          <path
            d="M7 7h8"
            stroke="#1F4FB6"
            strokeWidth="1.2"
            strokeLinecap="round"
          />
          <path
            d="M7 11h8"
            stroke="#1F4FB6"
            strokeWidth="1.2"
            strokeLinecap="round"
          />
          <path
            d="M7 15h5"
            stroke="#1F4FB6"
            strokeWidth="1.2"
            strokeLinecap="round"
          />
        </svg>
      );
    case "archive":
    case "file":
      return (
        <svg
          className={className}
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="3"
            y="5"
            width="18"
            height="14"
            rx="2"
            fill="#F5F7FA"
            stroke="#D7E1FA"
          />
          <path
            d="M7 9h10"
            stroke="#1F4FB6"
            strokeWidth="1.2"
            strokeLinecap="round"
          />
          <rect
            x="9"
            y="13"
            width="6"
            height="2"
            rx="1"
            fill="#fff"
            stroke="#1F4FB6"
          />
        </svg>
      );
    case "export":
    case "metadata":
      return (
        <svg
          className={className}
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 3v10"
            stroke="#1F4FB6"
            strokeWidth="1.6"
            strokeLinecap="round"
          />
          <path
            d="M8 7l4-4 4 4"
            stroke="#1F4FB6"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <rect
            x="4"
            y="14"
            width="16"
            height="6"
            rx="2"
            fill="#fff"
            stroke="#1F4FB6"
            strokeWidth="1.2"
          />
        </svg>
      );
    case "search":
    case "lookup":
      return (
        <svg
          className={className}
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="11" cy="11" r="5" stroke="#1F4FB6" strokeWidth="1.4" />
          <path
            d="M21 21l-4.3-4.3"
            stroke="#1F4FB6"
            strokeWidth="1.6"
            strokeLinecap="round"
          />
        </svg>
      );
    default:
      return (
        <svg
          className={className}
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="12"
            cy="12"
            r="9"
            stroke="#1F4FB6"
            strokeWidth="1.2"
            fill="#EEF6FF"
          />
        </svg>
      );
  }
}
